import React from 'react';
import { RetrieveRequest } from '../../../utilities/services/RequestService';
import { getOptionsDeactive } from '../../../utilities/actions/Helpers';
import { Alert } from '../..';
import SelectBase from './SelectBase';
import { api } from '../../../config/Services';

class AirlineSelect extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            options: [],
            isLoading: false
        }
    }

    componentDidMount(){
        if(this.props.forceRender){
            this.retrieveData();
        }
    }

    getValue = (airlinecode = null, field = null) => {
        const { options } = this.state;
        let result = null;
        let detailoptions = options.filter(obj => obj.value === airlinecode)[0];
        result = (detailoptions && detailoptions[field]) ? detailoptions[field] : null;
        return result;
    }

    retrieveData(criteria = {}, fieldinactive = {}, actionspage = 'create') {
        let paging = { limit: -1, page: 1 }
        let sort = { airlinename: 'asc' };
        let url = api.url.masterdata.airline.retrieve;
        criteria.active = true;
        let column = [];
        this.setState({ isLoading: true });
        RetrieveRequest(url, criteria, sort, paging, column).then((response) => {
            if (response.status.responsecode.substring(0, 1) === '0') {
                //remapping for base option select2
                var options = response.result.map(obj => {
                    var result2 = {};
                    result2['label'] = obj.airlinename;
                    result2['value'] = obj.airlinecode;
                    result2['alliancetype'] = obj.alliancetype;
                    return result2;
                });

                //if options deactive
                const { airlinecode, airlinename } = fieldinactive;
                if (airlinecode) {
                    options = getOptionsDeactive(actionspage, options, airlinecode, airlinename);
                }

                this.setState({ options, isLoading: false });
            } else {
                Alert.error(response.status.responsemessage);
            }
        });
    }

    render() {
        return (<SelectBase {...this.props} options={this.state.options} isLoading={this.state.isLoading} />)
    }

}

export default AirlineSelect;